import SearchNothingFoundIcon from '/public/icons/not-found.svg';

export const SelectClientModalEmptyState = () => {
  return (
    <div className="flex flex-col items-center justify-center h-[50vh] gap-[24px] px-4 max-md:h-auto max-md:gap-4 max-md:py-8">
      <SearchNothingFoundIcon
        viewBox="0 0 80 80"
        className="w-20 h-20 fill-current text-black max-md:h-15 max-md:w-15"
      />
      <div className="flex flex-col items-center justify-center gap-2">
        <h3 className="light text-black text-center max-md:!text-xl max-md:!leading-[110%]">No matching results</h3>
        <p className="text-body-regular text-black text-center max-md:!text-sm max-md:!leading-[150%]">
          We couldn’t find any matches for your search. <br /> Try a different keyword or check your spelling.
        </p>
      </div>
    </div>
  );
};
